
                import wasm from "../../dist/pkg/web/perspective.cpp.wasm";
                async function get_wasm() {
                    return new URL(wasm, import.meta.url);
                }

                export default get_wasm();
            